const TooltipConditionalWrapper = ({ condition, wrapper, children }) => 
  condition ? wrapper(children) : children;
export default TooltipConditionalWrapper;